import { FormControlLabel, styled } from '@mui/material';

export const StyledFormControlLabel = styled(FormControlLabel)(
	({ theme }) => `
	margin-left: -9px;
	color: ${theme.palette.text.primary};
	display:flex;
	width: fit-content;

	.MuiButtonBase-root{
		align-self:start;
	}
	`
);
